import React, { useContext, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"
import { useHistory } from "react-router"
import { AuthContext } from "../providers/AuthProvider"
import { executeRequest, RequestType } from "../api/APIUtils"
import endpoints from "../api/endpoints"
import Auth from "../auth/Auth"
import routes from "../routes"
import { ConnectedUser } from "../interfaces/ConnectedUser"
import { WhiteLabelConfig } from "../interfaces/WhiteLabelConfig"

const Auth0Callback: React.FunctionComponent = () => {
    const { isLoading, error, getAccessTokenSilently } = useAuth0()
    const { onLogin, onSetWhiteLabelConfig, whiteLabelConfig } = useContext(AuthContext)
    const history = useHistory()

    useEffect(() => {
        if (isLoading || error) return

        const fetchUser = async () => {
            try {
                const accessToken = await getAccessTokenSilently()

                // Temporarily seed Auth storage so executeRequest can attach the token
                Auth.login({ token: accessToken } as ConnectedUser)

                const { id, email, orgId, tempWhitelabelContext } = await executeRequest({
                    endpoint: endpoints.auth.AUTH0_ME,
                    requestType: RequestType.GET,
                    withToken: true
                })

                const connectedUser: ConnectedUser = {
                    id,
                    email,
                    tempOrgId: orgId,
                    tempWhitelabelContext,
                    token: accessToken
                }

                onLogin(connectedUser)

                if (whiteLabelConfig.context !== tempWhitelabelContext) {
                    const updated: WhiteLabelConfig = {
                        context: tempWhitelabelContext,
                        lang: whiteLabelConfig.lang
                    }
                    onSetWhiteLabelConfig(updated)
                }

                history.push(routes.SELECT_SITE)
            } catch (err) {
                console.error("Auth0 callback error", err)
                history.push(routes.LOGIN)
            }
        }

        fetchUser()
    }, [isLoading, error])

    return <div className="loader loader-xl" />
}

export default Auth0Callback
